import React, { Component } from "react";
import BasicCommonFileSettings from "./BasicCommonFileSettings";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
//import Switch from "@material-ui/core/Switch";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import { Trans, withTranslation } from "react-i18next";

const styles = (theme) => ({
  container: {
    margin: "25px 0",
    display: "flex",
    flexDirection: "column",
  },
});
export class BasicSharepointSettings extends Component {
  state = {
    sharepointURL: "",
    sharepointSiteURL: "",
    authOnDomain: false,
  };

  componentDidMount() {
    this.parseEditKs();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state !== prevState) {
      if (this.state.authOnDomain !== prevState.authOnDomain) {
        this.settingsUpdated();
      }
    }

    if (this.props.editKs !== prevProps.editKs) {
      this.parseEditKs();
    }
  }

  parseEditKs = () => {
    if (this.props.editKs && Object.keys(this.props.editKs).length > 0) {
      if (this.props.editKs.url) {
        let urls = this.props.editKs.url.split(":");
        this.setState({ sharepointURL: urls[0], sharepointSiteURL: urls[1] });
      }
      this.setState({
        authOnDomain: !!this.props.editKs.properties.spiderProperties
          .authOnDomain,
      });
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.container}>
        <Typography gutterBottom variant="h5">
          <Trans i18nKey="create_ks_sharepoint_settings" />
        </Typography>
        <TextField
          style={{ width: "50%" }}
          id="sharepoint-url"
          label={this.props.t("create_ks_sharepoint_url")}
          onChange={this.updateSharepointURL}
          value={this.state.sharepointURL}
          helperText="Your SharePoint domain, e.g. kps.sharepoint.com"
        />
        <TextField
          style={{ width: "50%" }}
          id="sharepoint-site-url"
          label={this.props.t("create_ks_sharepoint_site_url")}
          onChange={this.updateSharepointSiteURL}
          value={this.state.sharepointSiteURL}
          helperText="e.g. /sites/testsite. Leave blank for the root site."
        />
      </div>
    );
  }

  updateSharepointURL = (e) => {
    let divisionString =  ":" ;
    this.setState({
      sharepointURL: e.target.value,
    });
    this.props.updateURL(e.target.value + divisionString + this.state.sharepointSiteURL);
  };

  updateSharepointSiteURL = (e) => {
    let divisionString = ":" ;
    this.setState({
      sharepointSiteURL: e.target.value,
    });
    if (!this.state.sharepointURL && !e.target.value) {
      this.props.updateURL("");
    } else {
      this.props.updateURL(this.state.sharepointURL + divisionString + e.target.value);
    }
  };

  settingsUpdated = () => {
    this.props.setSpiderProperties({
      authOnDomain: this.state.authOnDomain,
    });
  };
}

export default withStyles(styles)(withTranslation()(BasicSharepointSettings));
